import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import type { SnackVariantKey } from '@clearverify/constants';

import { useNotification } from 'src/hooks/app';

export const NotificationSection: React.FC = () => {
  const { spawnNotification } = useNotification();

  return (
    <Box component="section">
      <Typography variant="h3">Notifications</Typography>

      <Box display="flex" gap={2} mt={2}>
        {snackTypes.map(snackType => (
          <Button
            key={snackType}
            variant="contained"
            color="primary"
            onClick={() => spawnNotification(snackType, snackType)}
          >
            {snackType}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

const snackTypes: SnackVariantKey[] = ['error', 'info', 'success', 'warning'];
